<!-- The Underlyings table (CR-20260929-001 M1b): custom rows, hedge-pad style. -->
<div class="table" [class.locked]="!this.unlocked">

  <!-- header row -->
  <div class="row header">
    <!-- SIDE + TYPE lead every table (owner, 2026-09-29 vrequest, item 4): the Multi-Trade Pad's side colours. -->
    <div class="column side" title="The direction of the position">Side</div>
    <div class="column type" title="The kind of asset on the row">Type</div>
    <div class="column symbol">Symbol</div>
    <div class="column shares" title="Shares for stocks; contracts for options and futures">Quantity</div>
    <div class="column lock"></div>
    <div class="column price">Price</div>
    <div class="column dollars">$ Value</div>
    <div class="column pct">% of Portfolio</div>
    <div class="column lock"></div>
    <div class="column beta">Beta</div>
    <div class="column beta-delta" title="Beta-Δ = quantity × instrument point value × beta; calls also use delta (currently 1)">β-Δ</div>
    <!-- The session column (CR-20260930-001 M2): the row's order block — copy it, its lock, revoke it. -->
    <div class="column status" title="Order: export to ToS / exported and locked / revoke">Order</div>
    <div class="column remove"></div>
  </div>

  <!-- The rows scroll in a DevExtreme scroll view; the header above and the Total below stay pinned
       (owner, 2026-09-29 vrequest). -->
  <dx-scroll-view class="rows" [useNative]="false" showScrollbar="onHover">

  <div class="empty" *ngIf="!this.rows?.length">No Underlyings Yet — Press "Add Item"</div>

  <!-- one row per underlying -->
  <ng-container *ngFor="let row of this.rows; let i = index; trackBy: this.trackRow">
  <div *ngIf="i > 0 && row.assetType === 'Call' && this.rows[i - 1].assetType !== 'Call'"
       class="asset-group-separator" aria-hidden="true"></div>
  <div class="row leg" [class.crossed-out]="row.crossedOut" [class.expired]="this.isExpired(row)"
       [class.held]="row.origin === 'held'">

    <!-- The selection checkbox column is gone (owner, 2026-09-29 smoke 2: "we don't need it yet"). -->
    <div class="column side" [class.removed]="row.crossedOut" [class.buy]="row.side === 'Buy'" [class.sell]="row.side === 'Sell'">
      <!-- A held (portfolio-loaded) row keeps its side: the position exists, its direction is a fact (owner, 2026-09-29). -->
      <dx-select-box [items]="this.sides" [value]="row.side" [inputAttr]="this.centered"
                     [disabled]="this.isExpired(row) || !this.unlocked || row.crossedOut" [readOnly]="row.origin === 'held' || row.assetType === 'Call'"
                     (onValueChanged)="this.onSideChanged(row, $event)">
        <div *dxTemplate="let s of 'item'" class="side-item" [class.buy]="s === 'Buy'" [class.sell]="s === 'Sell'">{{ s }}</div>
      </dx-select-box>
    </div>

    <div class="column type" [class.removed]="row.crossedOut">{{ row.assetType }}</div>

    <div class="column symbol" [class.removed]="row.crossedOut" [title]="this.displayOf(row)">{{ this.displayOf(row) }}</div>

    <!-- Large spin buttons, step 1, minimum 1 (owner, 2026-09-29 smoke 2). A CHANGED row (M2, §6.2) shows the
         cell split: the before count on the left, the editor on the right, on yellow. -->
    <div class="column shares" [class.removed]="row.crossedOut" [class.changed]="this.beforeOf(row, 'shares') !== null">
      <span class="before" *ngIf="this.beforeOf(row, 'shares') !== null" [title]="'Before: ' + this.beforeOf(row, 'shares') + ' shares'">{{ this.beforeOf(row, 'shares') }}</span>
      <dx-number-box [value]="row.shares" [min]="1" [step]="1" [showSpinButtons]="true" [useLargeSpinButtons]="true"
                     [inputAttr]="this.centered" format="#,##0" [disabled]="this.isExpired(row) || !this.unlocked || row.crossedOut || this.isLocked(row)"
                     (onValueChanged)="this.onSharesChanged(row, $event)"></dx-number-box>
    </div>

    <div class="column lock" [class.removed]="row.crossedOut" (click)="!this.isExpired(row) && this.unlocked && !row.crossedOut && !this.isLocked(row) && this.sharesLockToggled.emit(row)"
         title="Lock the share count through balance moves">
      <i *ngIf="!this.isExpired(row)" class="fa" [ngClass]="row.sharesLock ? 'fa-lock on' : 'fa-unlock off'"></i>
    </div>

    <div class="column price" [class.removed]="row.crossedOut" [class.stale]="row.priceStale"
         [title]="row.priceStale ? 'Stale: no quote for a while; last price shown' : ''">
      {{ row.price === null ? '—' : (row.price | currency:'USD':'symbol':'1.2-2') }}
    </div>

    <div class="column dollars" [class.removed]="row.crossedOut">
      {{ row.dollars === null ? '—' : (row.dollars | currency:'USD':'symbol':'1.2-2') }}
    </div>

    <!-- Large spin buttons, step 1 % (owner, 2026-09-29 smoke 2). -->
    <div class="column pct" [class.removed]="row.crossedOut">
      <dx-number-box [value]="row.pct" [min]="0" [step]="1" [showSpinButtons]="true" [useLargeSpinButtons]="true"
                     [inputAttr]="this.centered" format="#,##0.##'%'" [disabled]="this.isExpired(row) || !this.unlocked || row.crossedOut || this.isLocked(row)"
                     (onValueChanged)="this.onPercentChanged(row, $event)"></dx-number-box>
    </div>

    <div class="column lock" [class.removed]="row.crossedOut" (click)="!this.isExpired(row) && this.unlocked && !row.crossedOut && !this.isLocked(row) && this.pctLockToggled.emit(row)"
         title="Lock the % of portfolio through balance moves">
      <i *ngIf="!this.isExpired(row)" class="fa" [ngClass]="row.pctLock ? 'fa-lock on' : 'fa-unlock off'"></i>
    </div>

    <div class="column beta" [class.removed]="row.crossedOut">
      {{ row.beta === null ? '—' : (row.beta | number:'1.2-2') }}
    </div>

    <!-- Whole numbers (owner, 2026-09-29 vrequest, item 7): the sheet rounds .5 and up to the ceiling. -->
    <div class="column beta-delta" [class.removed]="row.crossedOut">
      {{ row.betaDelta === null ? '—' : (row.betaDelta | number:'1.0-0') }}
    </div>

    <!-- The session column (M2): copy the row's order block / the lock of a copied block / revoke it. -->
    <div class="column status" [class.locked]="this.isLocked(row)" [class.overdue]="this.isOverdue(row)">
      <i *ngIf="this.canCopy(row)" class="dx-icon dx-icon-export copy" title="Export this order: opens the Export window on it" (click)="!this.isExpired(row) && this.unlocked && this.copyClicked.emit(row)"></i>
      <!-- A SHIELD, not a lock (owner, smoke 1): the padlock is the balance/OTM lock's icon. -->
      <i *ngIf="!this.isExpired(row) && this.isLocked(row)" class="fa fa-shield-alt lock" [title]="this.isOverdue(row) ? 'Exported to ToS, OVERDUE: apply its fill in Portfolio Hedging, or revoke' : 'Exported to ToS: protected until its fill is applied in Portfolio Hedging, or revoked'"></i>
      <i *ngIf="!this.isExpired(row) && this.isLocked(row)" class="fa fa-undo revoke" title="Revoke the export: back to not exported, the row unlocks" (click)="!this.isExpired(row) && this.unlocked && this.revokeClicked.emit(row)"></i>
    </div>

    <!-- The far-right, last column: X on a live row, restore on a crossed-out one (the hedge pad's icons). -->
    <div class="column remove" [class.disabled]="!this.unlocked || this.isLocked(row)">
      <i *ngIf="!this.isExpired(row) && !row.crossedOut" class="fa fa-times-circle" title="Remove" (click)="!this.isExpired(row) && this.removeClicked.emit(row)"></i>
      <i *ngIf="!this.isExpired(row) && row.crossedOut" class="fa fa-undo" title="Restore" (click)="!this.isExpired(row) && this.restoreClicked.emit(row)"></i>
    </div>
  </div>

  </ng-container>
  </dx-scroll-view>

  <!-- totals row: the table's own, pinned under the scrolling rows (owner, M1a smoke + 2026-09-29). -->
  <div class="row total" *ngIf="this.rows?.length && this.totals">
    <div class="column side"></div>
    <div class="column type"></div>
    <div class="column symbol">Total</div>
    <div class="column shares"></div>
    <div class="column lock"></div>
    <div class="column price"></div>
    <div class="column dollars" [class.red]="!this.totals.dollarsConsistent"
[title]="this.totals.dollarsConsistent ? '' : 'Stock value exceeds the maximum stock allocation: reduce exposure before exporting stock buys'">
      {{ this.totals.dollars | currency:'USD':'symbol':'1.2-2' }}
    </div>
    <div class="column pct" [class.red]="!this.totals.pctConsistent"
         [title]="this.totals.pctConsistent ? '' : 'The % column exceeds 100: the sheet needs rebalancing'">
      {{ this.totals.pct | number:'1.2-2' }}%
    </div>
    <div class="column lock"></div>
    <div class="column beta"></div>
    <div class="column beta-delta">{{ this.totals.betaDelta === null ? '—' : (this.totals.betaDelta | number:'1.0-0') }}</div>
    <div class="column status"></div>
    <div class="column remove"></div>
  </div>

</div>
